import { render, staticRenderFns } from "./ClientFormAutocomplete.vue?vue&type=template&id=5f6de67d&scoped=true&"
import script from "./ClientFormAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ClientFormAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./ClientFormAutocomplete.vue?vue&type=style&index=0&id=5f6de67d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6de67d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemTitle,VTextField})
